<template>
  <section id="photo-carousel" class="photo-carousel-section py-16 bg-gray-900">
    <div class="container mx-auto px-4">
      <h2 class="text-4xl font-bold mb-8 text-center text-white">Galerij</h2>
      <div class="carousel-container relative">
        <div
            class="carousel-inner"
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
        >
          <div v-for="(photo, index) in photos" :key="index" class="carousel-slide">
            <img :src="photo.src" :alt="photo.alt" class="w-full h-full object-cover" />
          </div>
        </div>

        <!-- Navigatie pijlen -->
        <button @click="prevSlide" class="carousel-control prev absolute left-0">
          &#10094;
        </button>
        <button @click="nextSlide" class="carousel-control next absolute right-0">
          &#10095;
        </button>

        <!-- Indicatoren -->
        <div class="carousel-indicators absolute bottom-0 left-0 right-0 flex justify-center">
          <span
              v-for="(photo, index) in photos"
              :key="index"
              @click="goToSlide(index)"
              :class="{ active: index === currentSlide }"
              class="carousel-indicator"
          ></span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      currentSlide: 0,
      photos: [
        { src: require('@/assets/carousel/foto1.webp'), alt: 'Foto 1' },
        { src: require('@/assets/carousel/foto2.webp'), alt: 'Foto 2' },
        { src: require('@/assets/carousel/foto3.webp'), alt: 'Foto 3' },
        { src: require('@/assets/carousel/foto4.webp'), alt: 'Foto 4' },
        { src: require('@/assets/carousel/foto5.webp'), alt: 'Foto 5' },
      ],
      interval: null,
    };
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.photos.length;
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.photos.length) % this.photos.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    startAutoSlide() {
      this.interval = setInterval(() => {
        this.nextSlide();
      }, 5000); // Verander de slide elke 5 seconden
    },
    stopAutoSlide() {
      clearInterval(this.interval);
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeDestroy() {
    this.stopAutoSlide();
  },
};
</script>
<style scoped>
.photo-carousel-section {
  position: relative;
  overflow: hidden;
}

.carousel-container {
  position: relative;
  width: 100%;
  max-width: 1150px;
  margin: 0 auto;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.carousel-slide {
  min-width: 100%;
  overflow: hidden;
}

.carousel-control {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 30px;
  padding: 10px;
  border: none;
  cursor: pointer;
}

.carousel-control.prev {
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}

.carousel-control.next {
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.carousel-indicators {
  bottom: 10px;
  text-align: center;
}

.carousel-indicator {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
  display: inline-block;
  opacity: 0.5;
}

.carousel-indicator.active {
  opacity: 1;
}
</style>
